import {makeStyles} from '@logistics-frontend/blocks'

export const useClasses = makeStyles(theme => ({
  title: {
    // проблемы старой темы
    // eslint-disable-next-line
    fontWeight: theme.typography.fontWeightMedium as any,
    fontSize: 18,
    padding: theme.spacing(1),
  },
  orderCard: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#F7F6F3',
    padding: theme.spacing(2),
    margin: `${theme.spacing(2)}px 0`,
  },
  selectedOrderCard: {
    backgroundColor: 'unset',
    boxShadow: '0 3px 32px rgba(138, 141, 145, .15)',
  },
}))
